<template>
  <div class="detail-page">
    <div class="header">
      <img
        class="mascot"
        :src="require('@/assets/imgs/promotionGift/detailLogo.png')"
      />
      <div class="title">哎呀，人太多啦</div>
      <div class="subTitle">活动太火爆了，请退出页面重新领取</div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.detail-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fdddf4 0%, #e0f1fb 100%);
  padding: 16px 12px 24px;
  box-sizing: border-box;
  .header {
    text-align: center;
    .mascot {
      width: 77px;
      height: 91px;
      object-fit: contain;
    }
    .title {
      margin-top: 6px;
      font-size: 18px;
      font-weight: normal;
      color: #1c0960;
    }
    .subtitle {
      margin-top: 12px;
      color: #6a6a6a;
      font-size: 12px;
    }
  }
}
</style>
